import { createSlice } from '@reduxjs/toolkit';

import { fetchPreviousCalls } from './thunks';

import type { PreviousCallsState } from 'features/call/previous-calls/interfaces';

export const initialPreviousCallsState: PreviousCallsState = {
  previousCalls: [],
  isLoadingPreviousCalls: false,
};

const previousCallsSlice = createSlice({
  name: 'previous-calls',
  initialState: initialPreviousCallsState,
  reducers: {
    resetPreviousCallsState: () => initialPreviousCallsState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPreviousCalls.pending, (state) => {
        state.isLoadingPreviousCalls = true;
      })
      .addCase(fetchPreviousCalls.fulfilled, (state, action) => {
        state.isLoadingPreviousCalls = false;
        state.previousCalls = action.payload || [];
      })
      .addCase(fetchPreviousCalls.rejected, (state) => {
        state.isLoadingPreviousCalls = false;
        state.previousCalls = [];
      });
  },
});

export const { resetPreviousCallsState } = previousCallsSlice.actions;

export const previousCallsReducer = previousCallsSlice.reducer;
